






















import { Watch, Component, Vue } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { namespace } from 'vuex-class'
const ui = namespace('ui')

@Component
export default class App extends Vue {
    showSidebar: boolean = false
    showScrollbar: boolean = false
    noBackground: boolean = false
    @ui.State readonly minimalizedNav!: boolean
    @ui.Action minimizeNav!: () => Promise<void>
    @ui.Action maximizeNav!: () => Promise<void>

    @Watch('$route')
    onRouteChange(to: Route) {
        this.showSidebar = to.meta.showSidebar ?? true
        this.showScrollbar = to.meta.showScrollbar ?? true
        this.noBackground = to.meta.noBackground ?? true

        // never show sidebar without user or company
        if (!this.$currentUser || !this.$currentCompany) {
            this.showSidebar = false
        }
    }

    async mounted() {
        // Fix header dissapearing after HMR.
        this.onRouteChange(this.$route)
    }

    get showHeader(): boolean {
        return this.showSidebar
            && this.$currentCompany !== null
            && this.$currentUser !== null
    }

    get componentClasses() {
        return {
            'app': true,
            'app--beta-one': this.$currentUser?.betaOptInEnabled,
        }
    }
}
